/* PrimeBuild – "Cada producto, su propia tienda" (fichas de producto).
   1) El precio de la portada y del cierre sigue a la variante elegida.
   2) Productos relacionados de Shopify en tarjetas PrimeBuild (se cargan al acercarse).
   3) Botón "Read full description" de las descripciones sin formato.
   4) Botón para parar / seguir las cintas en movimiento. */
(function () {
  if (window.__pbxInit) return;
  window.__pbxInit = true;

  function mainPrice() {
    var root = document.querySelector('.pbp-pdp .product-details product-price [ref="priceContainer"]') ||
      document.querySelector('.product-details product-price [ref="priceContainer"]');
    if (!root) return null;
    var el = root.querySelector('.price__sale:not(.price__hidden) .price-item--sale') ||
      root.querySelector('.price__regular:not(.price__hidden) .price') ||
      root.querySelector('.price');
    var t = el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
    return t || null;
  }

  function syncPrice() {
    var t = mainPrice();
    if (!t) return;
    document.querySelectorAll('[data-pbx-hero-price]').forEach(function (box) {
      var a = box.querySelector('[data-pbx-amount]');
      if (a && a.textContent.trim() !== t) a.textContent = t;
      var f = box.querySelector('[data-pbx-from]');
      if (f) f.hidden = true;
    });
  }

  document.addEventListener('variant:update', function () {
    setTimeout(syncPrice, 80);
    setTimeout(syncPrice, 500);
  });

  function initRelated(root) {
    (root || document).querySelectorAll('[data-pbz-rel][data-url]:not([data-pbz-ready])').forEach(function (grid) {
      grid.setAttribute('data-pbz-ready', '');
      var load = function () {
        fetch(grid.getAttribute('data-url'), { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (html) {
            if (!html) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('[data-pbz-rel]');
            if (fresh && fresh.querySelector('[data-pbz-real]')) grid.innerHTML = fresh.innerHTML;
          })
          .catch(function () {});
      };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); load(); }
        }, { rootMargin: '800px 0px' });
        io.observe(grid);
      } else {
        load();
      }
    });
  }

  function initMore(root) {
    (root || document).querySelectorAll('[data-pbx-more]:not([data-pbx-ready])').forEach(function (box) {
      box.setAttribute('data-pbx-ready', '');
      var body = box.querySelector('.pbx-full__body');
      var btn = box.querySelector('.pbx-full__toggle');
      if (!body || !btn) return;
      function fits() {
        if (!box.classList.contains('is-closed')) return;
        var pending = Array.prototype.some.call(body.querySelectorAll('img'), function (i) { return !i.complete; });
        if (!pending && body.scrollHeight <= body.clientHeight + 40) { box.classList.remove('is-closed'); btn.hidden = true; }
      }
      btn.addEventListener('click', function () {
        var open = box.classList.contains('is-closed');
        box.classList.toggle('is-closed', !open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        var span = btn.querySelector('span');
        if (span) span.textContent = open ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
        if (!open) box.scrollIntoView({ block: 'nearest' });
      });
      fits();
    });
  }

  function initPause(root) {
    (root || document).querySelectorAll('[data-pbx-pause]:not([data-pbx-ready])').forEach(function (btn) {
      btn.setAttribute('data-pbx-ready', '');
      btn.addEventListener('click', function () {
        var paused = btn.getAttribute('aria-pressed') !== 'true';
        btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        if (btn.parentElement) btn.parentElement.toggleAttribute('data-paused', paused);
      });
    });
  }

  function init(root) {
    initRelated(root);
    initMore(root);
    initPause(root);
    if (/[?&]variant=/.test(location.search)) syncPrice();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
